import React from "react";
import LiveRateTable from "./LiveRateTable";

const LiveRates = () => {
  return (
    <>
      <div className="container px-12 mx-auto md:py-12 py-6">
        <h2 className="text-center text-gray-800 text-4xl font-bold">
          Live exchange rates
        </h2>
        <p className="text-center text-gray-500 text-lg font-semibold">
          Compare 100+ currencies in real time & find the right moment to
          transfer funds
        </p>
        
        <LiveRateTable />
      </div>
    </>
  );
};

export default LiveRates;
